import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Guru Suryaprakash </span>
            from <span className="purple"> Virudhunagar, Tamil Nadu.</span>
            <br />
            I am currently doing Master of Computer Applications at KEC Erode
            <br />
            I have completed B.Sc in Computer Science at ANJAC Sivakasi
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Motion Editing
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Strive to build things that make a difference!"{" "}
          </p>
          <footer className="blockquote-footer">Guru</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
